module.exports = __webpack_public_path__ + "static/zoom-drain-logo-1e848beaf4faaf20f49e37cec43a97ef.svg";